/* src/app/dynamic-forms/form-view/form-view-rich-text/form-view-rich-text.component.scss */
ngx-editor {
  height: 100%;
  overflow: auto;
}
::ng-deep {
}
::ng-deep .NgxEditor {
  height: 100%;
  overflow-y: auto;
}
::ng-deep .NgxEditor__Content {
  min-height: 100%;
}
.customtextarea {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=form-view-rich-text.component.css.map */
